import {Component, OnInit} from '@angular/core';
import {LoadingController, ModalController} from '@ionic/angular';
import {NewDocumentService} from '../../services/new-document.service';
import {ServiceJobDetailsPage} from '../service-job-details/service-job-details.page';
import {ServiceJobDTOModel} from '../../models/service-job-DTO.model';
import {RefreshdatabaseService} from '../../services/database/refreshdatabase.service';
import {ConfigurationModel} from '../../models/configuration.model';
import {ConfigurationService} from '../../services/configuration.service';
import {TestConnectionService} from '../../services/test-connection.service';
import {StateManagerService} from '../../services/state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {BarcodescannerComponent} from '../barcodescanner/barcodescanner.component';

import {DocumentTypes} from '../../definitions/document-types';
import {PicturesPermissionService} from '../../services/pictures-permission.service';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { ScanBarcodeService } from 'src/app/services/scan-barcode.service';
import { DetaillineDTOModel } from 'src/app/models/detaillineDTO.model';
import { GeneralService } from 'src/app/services/general.service';
import { BarcodeOptions } from 'src/app/definitions/barcode-options';

@Component({
    selector: 'app-service-job-list',
    templateUrl: './service-job-list.page.html',
    styleUrls: ['./service-job-list.page.scss'],
})

export class ServiceJobListPage implements OnInit {

    jobList: ServiceJobDTOModel[];
    config: ConfigurationModel;
    queryText = '';
    loading: any;
    customerJobs = true;
    workshopJobs = true;
    loadingJobs: boolean;

    constructor(private modalController: ModalController,
                private newDocumentService: NewDocumentService,
                private refreshDB: RefreshdatabaseService,
                private loadingController: LoadingController,
                private configService: ConfigurationService,
                private testConnection: TestConnectionService,
                private barcodeScanner: BarcodeScanner,
                private scanBarcodeService: ScanBarcodeService,
                private stateManager: StateManagerService,
                private generalService: GeneralService,
                private barcodeOptions: BarcodeOptions,
                private collectionNames: CollectionsNames,
                private picturesPermission: PicturesPermissionService) {
    }

    async ngOnInit() {
        // await this.loadingPopulateJobs();
        await this.populateJobs();
        this.config = await this.configService.getConfiguration();
    }

    async loadingPopulateJobs() {
        await this.loadingController.create({
            message: 'Loading Jobs...',
            translucent: true,
            // cssClass: 'custom-class custom-loading'
        }).then((overlay) => {
            this.loading = overlay;
            console.log(this.loading);
            this.loading.present();
        });
        this.populateJobs().then(data => {
            this.loading.dismiss();
        }).catch(() => {
            this.loading.dismiss();
        });
    }

    async populateJobs() {
        this.jobList = this.stateManager.getCollection(this.collectionNames.SERVICEJOB);
        try {
            this.loadingJobs = true;
            await this.testConnection.pingServer();
            await this.refreshDB.refreshJobList();
            await this.refreshDB.refreshJobListResource();
            this.jobList = this.stateManager.getCollection(this.collectionNames.SERVICEJOB);
        } catch (e) {
        }
        this.loadingJobs = false;
        console.log(this.jobList);
    }

    cancelService() {
        this.modalController.dismiss();
    }

    async openModalJobDetails(job: ServiceJobDTOModel) {
        if (!job) {
            job = this.newDocumentService.buildNewServiceJobObj();
        }
        const document = this.newDocumentService.buildServiceJobDocumentBean(job);
        const modal = await this.modalController.create({
            component: ServiceJobDetailsPage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                document: document
            }
        });

        modal.onDidDismiss().then(data => {
            if (data.data) {
                this.modalController.dismiss();
            } else {
                this.populateJobs();
            }
        });
        return await modal.present();
    }

    async refreshDocs(event: any) {
        await this.populateJobs();
        event.target.complete();
    }

    async filterJobs() {
        let tempJobList = this.stateManager.getCollection('servicejob') as ServiceJobDTOModel[];
        tempJobList.sort((a, b) => (a.jobNumber > b.jobNumber) ? 1 : -1);
        if (!this.customerJobs) {
            tempJobList = tempJobList.filter(tempJob => {
                return !!tempJob.servicedItem.pdesc && !!tempJob.servicedItem.reg;
            });
        }
        if (!this.workshopJobs) {
            tempJobList = tempJobList.filter(tempJob => {
                return !tempJob.servicedItem.pdesc && !tempJob.servicedItem.reg;
            });
        }

        this.jobList = tempJobList;
    }

    async scanBarcode() {
        await this.picturesPermission.checkPermissions();
        const job = this.newDocumentService.buildNewServiceJobObj();
        const document = this.newDocumentService.buildServiceJobDocumentBean(job);

        await this.picturesPermission.checkPermissions();
        this.barcodeScanner.scan(this.barcodeOptions.options).then(barcode => {
            console.log(barcode.text);
            this.handleScanResult(job,barcode.text);
        }).catch(err => {
            console.log(err);
        });


       /* const modal = await this.modalController.create({
            component: BarcodescannerComponent,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': document
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                console.log('Data REturned !!');
                console.log(dataReturned);
                job.servicedItem = dataReturned.data;
                this.openModalJobDetails(job);
            }
        });
        return await modal.present();*/
    }

    async handleScanResult(job,event) {
        console.log('Scan Result');
        console.log(event);
        let equipment = this.scanBarcodeService.findPlantItemByExactBarcode(event) as DetaillineDTOModel;
        if (equipment) {
            if (!equipment.qty) {
                equipment.qty = 1;
            }
            equipment = JSON.parse(JSON.stringify(equipment));
            job.servicedItem = equipment;
            this.openModalJobDetails(job);
        } else {
            await this.generalService.createToast('No match with barcode: ' + event);
        }
    }


}
